import { Component, Input, OnInit } from '@angular/core';
import { RenewalData } from '../../model/renewal-data';

@Component({
    selector: 'pme-renewal-info',
    templateUrl: './renewal-info.component.html',
    styleUrls: ['./renewal-info.component.scss'],
    standalone: false
})
export class RenewalInfoComponent implements OnInit {

  @Input() renewalInfo: RenewalData;

  constructor() { }

  ngOnInit(): void {
  }

  something(){
    
  }

}
